import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import { DetailsContent, DetailsInputFields } from "../data";
import { handleGlobalInputChange } from "../../../helpers/functions";
import { useFetchData } from "../../../helpers/api";
import Cookies from "js-cookie";
import InlineSpinner from "../../../components/loading/InlineSpinner";

const theKeyId = Cookies.get("kalista-web-Id");

const Details = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    phone: "",
    email: "",
    whatsapp: "",
    companyName: "",
    city: "",
    shippingAddress: "",
    state: "",
    country: "",
    zipCode: "",
    gstin: "",
    pan: "",
    website: "",
    msme: "",
  });

  const { data: customerData, isLoading } = useFetchData(
    ["customerProfile"],
    "/Customer/GetCustomer",
    { Code: theKeyId }
  );
  const data = customerData?.Data?.[0] || "";
  const addressData = customerData?.Address?.[0] || "";

  useEffect(() => {
    if (data) {
      setFormData({
        Name: data.Name || "",
        phone: data.Mobile || "",
        email: data.Email || "",
        whatsapp: data.WhatsappNo || "",
        companyName: data.CompanyName || "",
        city: addressData.City || "",
        shippingAddress: addressData.Address || "",
        state: addressData.State || "",
        country: addressData.Country || "",
        zipCode: addressData.ZipCode || "",
        gstin: "",
        pan: "",
        website: "",
        msme: "",
      });
    }
  }, [data, addressData]);

  const handleInputChange = (e) => handleGlobalInputChange(e, setFormData);

  const toggleEditMode = () => setIsEditing(!isEditing);

  return (
    <DashboardLayout pageClass="details_page">
      {isLoading ? (
        <div className="loading_screen">
          <InlineSpinner />
        </div>
      ) : (
        <>
          <div className="dashboard_header">
            <h5>Company Details</h5>
            <button onClick={toggleEditMode} className="button primary_btn">
              {isEditing ? "Close" : "Edit"}
            </button>
          </div>
          {!isEditing ? (
            <div className="dashboard_content">
              {DetailsContent.map((field) => (
                <div key={field.key} className={field.className || ""}>
                  {field.label}: <span>{formData[field.key]}</span>
                </div>
              ))}
            </div>
          ) : (
            <form
              className="dashboard_content form"
              onSubmit={() => {
                toggleEditMode();
              }}
            >
              {DetailsInputFields.map((field) => (
                <input
                  key={field.name}
                  name={field.name}
                  type={field.type || "text"}
                  value={formData[field.name]}
                  onChange={handleInputChange}
                  className={field.className || ""}
                  placeholder={field.label}
                />
              ))}
              <button type="submit" className="button primary_btn">
                Save
              </button>
            </form>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default Details;
